import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import { VideoSelectorForMetrics } from '../VideoSelectorForMetrics';
import { DateRange } from 'react-day-picker';
import { PeriodPicker } from '@/components/ui/period-picker';
import { VideoMetricsData } from '../hooks/useMetricsData';

interface EnhancedMetricsHeaderProps {
  selectedVideoId: string | null;
  onSelectVideo: (videoId: string, videoMP4?: string | null) => void;
  date?: DateRange;
  onDateChange: (date: DateRange | undefined) => void;
  videoData: VideoMetricsData | null;
  isLoading: boolean;
}

export function EnhancedMetricsHeader({
  selectedVideoId,
  onSelectVideo,
  date,
  onDateChange,
  videoData,
  isLoading
}: EnhancedMetricsHeaderProps) {
  useLanguage();
  return (
    <>
        {/* Select de vídeo */}
        <VideoSelectorForMetrics
          value={selectedVideoId || ''}
          onChange={(videoId, videoMP4) => videoId && onSelectVideo(videoId, videoMP4)}
          placeholder={translateInterfaceText("Selecionar Vídeo")}
          className="metrics-filter-select flex-1 md:flex-none md:w-[280px] h-[42px] filter-input-premium !border-[#E7EAF4] !rounded-[10px]"
        />
        
        {/* Calendário */}
        <PeriodPicker
          value={date}
          onChange={onDateChange}
          align="end"
          className="metrics-date-picker h-[42px] flex-1 md:flex-none md:min-w-[240px] rounded-[10px] md:rounded-[8px]"
        />
    </>
  );
}
